<section class="steps-section">
        <div class="container">
            <div style="padding-top: 40px; padding-bottom: 40px;">
                <div class="mat-row margin-auto text-center flex w-100">
                    <img src="/assets/images/logo_full_900.png" style="width:40%;" class="main-logo margin-auto" alt="Horizinns logo"/>
                </div>
                <div class="steps-header">
                    <p class="accent-text">READY TO EARN ON YOUR TERMS?</p>
                    <h2>2 Simple Steps to Get Started</h2>
                </div>

        <div class="steps-grid">
            @if(!accountCreated) {
                <div class="step-card" (click)="goToCreateAccount()">
                    <div class="step-number">1</div>
                    <div class="step-icon-wrapper">
                        <i class="fa-solid fa-user-plus"></i>
                    </div>
                    <h3>Create Account</h3>
                    <p>Set up your professional Horizinns profile to access the sales network.</p>
                </div>

            } @else {
                <div class="step-card completed">
                    <div class="step-number">1</div>
                    <div class="step-icon-wrapper">
                        <i class="fa-solid fa-check"></i>
                    </div>
                    <h3>Account Created</h3>
                    <p>Your account has been create successfully.</p>
                </div>
            }

            <div class="step-card" (click)="goToSalesTerms()">
                <div class="step-number">2</div>
                <div class="step-icon-wrapper">
                    <i class="fa-solid fa-file-signature"></i>
                </div>
                <h3>Sign Agreement</h3>
                <p>Complete the Sales Agent Structure and Terms form to formalize your role.</p>
            </div>

            <!-- <div class="step-card">
                <div class="step-number">3</div>
                <div class="step-icon-wrapper">
                    <i class="fa-solid fa-id-card-clip"></i>
                </div>
                <h3>Share Your ID</h3>
                <p>Provide your Sales Agent ID to Hosts.</p>
            </div> -->
        </div>

        <div class="bonus-actions">
            <div class="bonus-item">
                <mat-icon>search</mat-icon>
                <span>Locate property hosts</span>
            </div>
            <div class="bonus-item">
                <mat-icon>group_add</mat-icon>
                <span><strong>Refer other Sales Agents:</strong> Earn 10% lifetime commission</span>
            </div>
            <div class="bonus-item">
                <mat-icon>dashboard_customize</mat-icon>
                <span>Track your earnings in the Sales Dashboard</span>
            </div>
        </div>
            </div>
        </div>
    </section>